import { makeStyles } from '@material-ui/styles';
// import tinycolor from 'tinycolor2';

export default makeStyles(theme => ({
    st0: {
        stroke: '#FFFFFF',
    },

    st1: {
        stroke: '#FFFFFF',
        strokeMiterlimit: '10',
    },

    st2: {
        fill: 'none',
    },

    st3: {
        fill: '#FFFFFF',
    },

    st4: {
    },

    st5: {
        fontSize: '16px',
        fontWeight: '500',
    },

    st6: {
        clipPath: 'url(#SVGID_2_)',
    },

}));
